import { requestGet } from '@/common/request';

interface ResultData {
  emailType: TypeData[];
  jmType: TypeData[];
}

type TypeData = {
  code: '';
  desc: '';
  isReceiver: 0; // 1打开 0关闭
};

/**
 * 消息中心-消息开关状态列表
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1306832381
 */
export default function genericMsgSettingList(): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/messageTypeConfig');
}
